import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import NavigationItem from './NavigationItem';
import NavigationOverlay from './NavigationOverlay';

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const overlayState = useSelector((state) => state.overlay.status);
    const [activeSubmenu, setActiveSubmenu] = useState(null);

    const handleSubmenuToggle = (menuId) => {
        setActiveSubmenu(menuId);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isNavigationClick = event.target.closest(
                '.navbar, .navbar__menu, .navbar__link, .navbar__item'
            );

            if (!isNavigationClick && activeSubmenu) {
                setActiveSubmenu(null);
            }
        };

        if (activeSubmenu) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [activeSubmenu]);

    return (
        <>
            {overlayState && <NavigationOverlay />}
            <NavigationItem
                links={contentLinks}
                level={0}
                activeSubmenu={activeSubmenu}
                onSubmenuToggle={handleSubmenuToggle}
            />
        </>
    );
};

export default Navigation;
